import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function inviteUserAPI(userData) {
  const url = `${AWS_API_URL}/admin/users/invite`;

  const body = {
    data: {
      users: [
        {
          firstName: userData.firstName || '',
          lastName: userData.lastName || '',
          email: userData.email || '',
          phone: userData.phone || '',
          // Required fields with defaults
          address: userData.address || '',
          addressId: userData.addressId || '',
          areaId: userData.areaId || '',
          objectId: userData.objectId || 0,
          personalNumber: userData.personalNumber || '',
          postalCode: userData.postalCode || '',
          city: userData.city || '',
        },
      ],
    },
  };

  return postRequest(url, body, await authorize());
}
